import { createContext } from 'react';
import { NotificationToastAction, Severity } from '@sib/ui';

export type OpenNotificationParams = {
  key?: string;
  message: string;
  type: Severity;
  description?: string;
  cancelMutation?: () => void;
  undoableTimeout?: number;
  duration?: number;
  action?: NotificationToastAction;
};

export interface NotificationContextValue {
  open: (params?: OpenNotificationParams | null | void | false) => void;
  close: (key: string) => void;
  isExtension?: boolean;
}

export const NotificationContext = createContext<NotificationContextValue>({
  open: () => {
    console.error('NotificationProvider not found');
  },
  close: () => {
    console.error('NotificationProvider not found');
  },
} as NotificationContextValue);
